import { useState } from 'react';

import type { IUseStarRating } from './types';

export const useStarRating = ({ initialRating = 0, readOnly = false, onChange }: IUseStarRating) => {
  const [rating, setRating] = useState<number>(initialRating);

  const onRatingComplete = (value: number) => {
    if (readOnly) {
      return;
    }
    setRating(value);
    console.info(`Rating complete: ${value}`);
    if (onChange) {
      onChange(value);
    }
  };

  return {
    rating,
    onRatingComplete,
  };
};
